var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":_vm.clearable,"placeholder":"请选择角色"},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}},_vm._l((_vm.operType),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.value,"value":item.key}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }